import { ArtifactType } from './contexts/ArtifactContext/artifact.lib';

// Keyed off the gated schools mode, not the raw type: a stale `?mode=schools`
// with the flag off is ordinary magic everywhere else, so it must not be the
// one thing that still paints the school pink.
export const getMagicLayerStyle = (
  artifactType: ArtifactType | null,
  isSchoolsMode: boolean
) => {
  if (isSchoolsMode) {
    return 'magicSchoolsBackground';
  }
  if (artifactType === ArtifactType.Printable) {
    return 'magicPageBackground';
  }
  if (artifactType === ArtifactType.Page) {
    return 'magicPageTealBackground';
  }
  if (artifactType === ArtifactType.Planner) {
    return 'magicPlannerBackground';
  }
  return 'magicBackground';
};
